export default __webpack_public_path__ + "static/media/petrosian.5fc2ea0e.txt";